/**
 * Allowlist de Stripe Price IDs aceptados por POST /checkout-sessions, derivado de
 * `CATALOG_ITEMS` (catalog-prices.ts) — esa es la única fuente de precios; aquí no se
 * repite ningún priceId a mano.
 */

import { CATALOG_ITEMS } from "./catalog-prices"

export type StripePriceMode = "live" | "test"

const ALLOWED_STRIPE_PRICE_IDS: Record<StripePriceMode, ReadonlySet<string>> = {
	live: new Set(CATALOG_ITEMS.map(item => item.livePriceId)),
	test: new Set(CATALOG_ITEMS.map(item => item.testPriceId))
}

/** Deriva el modo Stripe a partir del secret key del Lambda/API. */
export function stripePriceModeFromSecretKey(secretKey: string): StripePriceMode {
	return secretKey.startsWith("sk_live_") ? "live" : "test"
}

export function isAllowedStripePriceId(priceId: string, mode: StripePriceMode): boolean {
	return ALLOWED_STRIPE_PRICE_IDS[mode].has(priceId)
}

/** Valida line items del checkout. Devuelve mensaje de error o `null` si todo es válido. */
export function validateCheckoutPrices(priceIds: string[], mode: StripePriceMode): string | null {
	for (const priceId of priceIds) {
		if (!isAllowedStripePriceId(priceId, mode)) {
			return "Uno o más productos no son válidos para el checkout."
		}
	}
	return null
}
